<template>
  <div class="footer">
    <div class="main">
      <div class="img">
        <img class="logo" :src="footerLogo" alt="">
        <a href="https://access.gaminglabs.com/Certificate/Index?i=324" target="_blank"><img class="certi" :src="certification" alt=""></a>
        <img class="certi" :src="gaIcon" alt="">
      </div>
      <div class="copyright" v-html="$dataManager.getters.copyright"></div>
    </div>
  </div>
</template>

<script>
  const footerLogo = require('@/assets/weblogob.png');
  const certification = require('@/assets/certification.png');
  const gaIcon = require('@/assets/ga-icon.png');
  export default {
    name: "uiFooter",
    data() {
      return {
        footerLogo: footerLogo,
        certification: certification,
        gaIcon: gaIcon,
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../style/footer';
</style>
